import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ProductsBiocatchEnum, StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { OpEnum } from '../../../shared/enums/op.enum';
import { CityModel } from '../../../shared/models/abre-cuentas.model';
import { ContactModel } from 'src/app/shared/models/contact.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CaptureService } from '../../../shared/services/capture/capture.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { BUSINESS_CONST } from '../../../shared/constants/business.constants';
import { getAppStatus } from 'single-spa';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
var ResidenceAbroadComponent = /** @class */ (function () {
    function ResidenceAbroadComponent(copyService, headerService, captureService, navigationService, abreCuentasService, parametersService, bioCatchService, channelCommunicatorService, taggingService, helperService, requestService) {
        this.copyService = copyService;
        this.headerService = headerService;
        this.captureService = captureService;
        this.navigationService = navigationService;
        this.abreCuentasService = abreCuentasService;
        this.parametersService = parametersService;
        this.bioCatchService = bioCatchService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.taggingService = taggingService;
        this.helperService = helperService;
        this.requestService = requestService;
        this.emptyCity = new CityModel();
        this.multiLines = true;
        this.enabledButton = true;
        this.headerService.show(true, true, true);
        this.checkboxList = [
            {
                id: 'checkbox1',
                label: this.copyService.copies.residence_abroad_copies.radio_button_text_yes,
                value: '1',
                checked: false,
            },
            {
                id: 'checkbox2',
                label: this.copyService.copies.residence_abroad_copies.radio_button_text_no,
                value: '2',
                checked: true,
            },
        ];
        this.district_option = this.abreCuentasService.getDistricts();
    }
    ResidenceAbroadComponent.prototype.ngOnInit = function () {
        this.initBioCatch();
        /* istanbul ignore else */
        if (this.abreCuentasService.getLiveAbroad().elementId === 1) {
            this.checkboxList[0].checked = true;
            this.checkboxList[1].checked = false;
        }
        var product = this.abreCuentasService.getproductSelected().product_code;
        if (product === ProductsBiocatchEnum.AHO || product === ProductsBiocatchEnum.NOM) {
            this.bioCatchService.changeContext(StepBiocatchEnum.captura, product, false, true);
        }
        // TODO: SETEO DE DATOS
        // this.abreCuentasService.setProspectResponse({ client: false });
        var status = getAppStatus('evidente');
        status === 'MOUNTED' ? this.helperService.unRegisterAplication('evidente') : console.log();
        // this.options = this.parametersService.getSetting(OpEnum.CITY_LIST);
        var selectedCity = this.abreCuentasService.getBirthplaceInfo();
        if (!!selectedCity && selectedCity.city_code) {
            this.selectedCity = this.abreCuentasService.getBirthplaceInfo();
            this.selected_district = this.selectedCity.district_id;
        }
        else {
            this.selectedCity = { city_code: '', country_code: '', province_code: 0, description: '' };
        }
        this.isPostLogin = this.abreCuentasService.getPostlogin();
        if (!this.isPostLogin) {
            this.optionss = this.parametersService.getSetting(OpEnum.ETHNIC_GROUP);
        }
        // SI NO ES CLIENTE SE HACE SETEO DE DATOS QUE LLEGAN DE EVIDENTE MASTER
        /* istanbul ignore else */
        if (!this.abreCuentasService.getProspectResponse().client && this.channelCommunicatorService.getChannelId() !== '141') {
            this.setContactInfo(this.abreCuentasService.getDocumentInfo());
        }
        this.selectedEthnicGroup = { ethnic_group_code: 0, ethnic_group_description: '' };
        this.enableButton();
    };
    /**
     * Summary Go to next Step
     */
    ResidenceAbroadComponent.prototype.next = function () {
        var _this = this;
        this.sendTagging('next', 'bottom', '2');
        if (this.abreCuentasService.getLiveAbroad().elementId === 1) {
            this.abreCuentasService.caseInfoError('301');
            this.navigationService.nextStep('301');
            this.navigationService.pageLoadTag('ErrorResidenciaExterior', ['pv39', 'pv191', 'pv169', '']);
            return;
        }
        this.captureService.sendProspectBirthplace(this.selectedCity).then(function () {
            _this.navigationService.nextStep('200');
        }).catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); });
    };
    /**
     * Summary Set propertys to Live Abroad
     * @param event
     */
    ResidenceAbroadComponent.prototype.radioButtonChange = function (event) {
        var radio = this.checkboxList.find(function (e) { return e.value === event.value; });
        if (!radio) {
            return;
        }
        this.abreCuentasService.setLiveAbroad({
            value: radio.label,
            elementId: parseInt(radio.value, 10),
            checked: true,
        });
    };
    /**
     * Summary Event for select a option for list selected, and set value in Input
     * @param option
     */
    ResidenceAbroadComponent.prototype.selectOption = function (event) {
        if (event.value) {
            this.selectedCity = this.options.find(function (e) { return (e.city_code === event.value.city_code) &&
                (e.province_code === event.value.province_code); }) || this.emptyCity;
            this.selectedCity.bp_city_code = this.selectedCity.city_code;
            this.selectedCity.bp_province_code = this.selectedCity.province_code;
            this.abreCuentasService.setBirthplaceInfo(this.selectedCity);
            this.enableButton();
            return;
        }
        this.selectedCity = { city_code: '', country_code: '', province_code: 0, description: '' };
        this.enableButton();
    };
    /**
     * Summary Event for select a option for list selected, and set value in Input
     * @param option
     */
    ResidenceAbroadComponent.prototype.selectOptions = function (event) {
        if (event.value) {
            this.selectedEthnicGroup.ethnic_group_code = event.value.id;
            this.selectedEthnicGroup.ethnic_group_description = event.value.value;
            this.abreCuentasService.setEthnicGroupInfo(this.selectedEthnicGroup);
        }
    };
    // TODO: SETEO DE contactInfo
    ResidenceAbroadComponent.prototype.setContactInfo = function (data) {
        var contactInfo = data;
        this.contactInfo = new ContactModel();
        this.contactInfo.email = contactInfo.email;
        this.contactInfo.mobile_number = contactInfo.mobile_number;
        this.abreCuentasService.setContactInfo(this.contactInfo);
        // TODO: AGREGAR CONDICION PARA QUE SOLO EN CUENTA NOMINA SE EJECUTE EL SERVICIO
        var product = this.abreCuentasService.getproductSelected();
        if (product.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL) {
            this.setDataProspectOccupation();
        }
    };
    // TODO: SETEO DE PROSPECT OCUPATION
    ResidenceAbroadComponent.prototype.setDataProspectOccupation = function () {
        var _this = this;
        this.abreCuentasService.setOccupationSelected(this.parametersService.getSetting(OpEnum.OCCUPATIONS_LIST)[0]);
        this.captureService.sendProspectOccupation().then(function (res) {
            if (!res) {
                return;
            }
            _this.abreCuentasService.setinfoInferredIncomes(res.body.data);
        });
    };
    ResidenceAbroadComponent.prototype.initBioCatch = function () {
        var product = this.abreCuentasService.getproductSelected().product_code;
        console.log('PRODUCTO----', product);
        this.bioCatchService.changeContext(StepBiocatchEnum.captura, product);
    };
    ResidenceAbroadComponent.prototype.sendTagging = function (value, position, event, extras) {
        var page = '28';
        this.taggingService.sendTaggValues(value, page, position, event, extras);
    };
    ResidenceAbroadComponent.prototype.getCitys = function (provence_id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requestService.cityBranches(provence_id).then(function (responseR) {
                            _this.city_option = responseR.body;
                            _this.options = _this.city_option.map(function (data) {
                                var codeDaneResidence = data.code_dane;
                                var codeDanelength = codeDaneResidence.length - 3;
                                return {
                                    city_code: codeDaneResidence.substring(codeDanelength),
                                    province_code: +codeDaneResidence.substring(0, codeDanelength),
                                    description: data.city,
                                    district_id: data.district.district_id,
                                };
                            });
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ResidenceAbroadComponent.prototype.selectOptionProvidence = function (event) {
        var valueResidence = event.value;
        console.log(event);
        if (valueResidence && valueResidence.trim() !== '') {
            this.selected_district = valueResidence;
            this.getCitys(valueResidence);
        }
        else {
            this.city_option = undefined;
            this.selectedCity = { city_code: '', country_code: '', province_code: 0, description: '' };
            this.selected_district = undefined;
        }
        this.enableButton();
    };
    ResidenceAbroadComponent.prototype.enableButton = function () {
        if (this.selectedCity.city_code !== '' && this.selected_district !== undefined) {
            this.enabledButton = false;
        }
        else {
            this.enabledButton = true;
        }
    };
    return ResidenceAbroadComponent;
}());
export { ResidenceAbroadComponent };
